import { Link } from "react-router-dom";

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20epic%20cinematic%20illustration%20with%20multiple%20anime%20characters%20in%20dynamic%20action%20poses%2C%20vibrant%20warm%20orange%20and%20crimson%20color%20palette%2C%20dramatic%20god%20rays%20lighting%2C%20fantasy%20and%20sci-fi%20elements%20blended%2C%20inspirational%20heroic%20atmosphere%2C%20high%20quality%20detailed%20artwork&width=1600&height=900&seq=hero-bg-2025&orientation=landscape"
        alt="奶水动漫在线 - 免费高清动漫在线观看平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-background-50"></div>
      <div className="absolute inset-0 flex items-center">
        <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
          <div className="max-w-2xl">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white font-heading leading-tight mb-4">
              奶水动漫在线
            </h1>
            <p className="text-base md:text-lg text-white/85 leading-relaxed mb-8 max-w-xl">
              海量高清动漫资源，免费在线观看。涵盖热门番剧、经典动漫、最新连载，随时随地畅享动漫世界的无限精彩。
            </p>
            <div className="flex flex-col sm:flex-row items-start gap-3">
              <Link
                to="/category/rexue"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                开始观看
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/15 backdrop-blur-sm text-white text-sm font-medium hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap border border-white/20"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}